import { render, staticRenderFns } from "./streams.vue?vue&type=template&id=4a66998e&"
import script from "./streams.vue?vue&type=script&lang=js&"
export * from "./streams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports